import React, {useContext} from 'react';
import classes from './DeviceCard.module.scss';
import {Link} from "react-router-dom";
import {observer} from "mobx-react-lite";
import {Context} from "../index";

const DeviceCard = observer(({devices}) => {
    const {things} = useContext(Context);
    const {ui} = useContext(Context);
    return (
        <div className={classes.container}>

            {devices.map((item) => {
                    return (
                        <div key={item?.id}>
                            <Link onClick={() => {
                                things.setThingId(item.id)
                                things.setThingKey(item.key)
                                things.setName(item.name)
                                things.setSerialNumber(item.serialNumber)
                                things.setModel(item.model)
                                things.setEquipment(item.equipment)
                                things.setIsDeviceOnline(item.isOnline)
                                item.settings && things.setSettings(item.settings)
                            }} className={classes.card} to={`../${item?.name || '-'}`}>
                                <div className={classes.item} style={ui.isSerialNumber ? {display: 'flex'} : {display: 'none'}}>{item?.serialNumber  || '-'}</div>
                                <div className={classes.item} style={ui.isModel ? {display: 'flex'} : {display: 'none'}}>{item?.model.toUpperCase()  || '-'}</div>
                                <div className={classes.item} style={ui.isSerialNumberMachine ? {display: 'flex'} : {display: 'none'}}>{item?.equipment.sn  || '-'}</div>
                                <div className={classes.item} style={ui.isCity ? {display: 'flex'} : {display: 'none'}}>{item?.equipment.city || '-'}</div>
                                <div className={classes.item} style={ui.isAddress ? {display: 'flex'} : {display: 'none'}}>{item?.equipment.address  || '-'}</div>
                                <div className={classes.item} style={ui.isObject ? {display: 'flex'} : {display: 'none'}}>{item?.equipment.facility  || '-'}</div>
                                <div className={classes.item} style={ui.isStatus ? {display: 'flex'} : {display: 'none'}}>{item?.isOnline === true ? <p style={{color: '#55ce5e'}}>Online</p> : <p style={{color: 'red'}}>Offline</p>}</div>
                            </Link>
                            <hr/>
                        </div>
                    )
                }
            )}

        </div>
    );
});

export default DeviceCard;
